import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { InventarioConsultaOrquestradorService } from '../../../../../shared/services/apis/orquestrador-suprimentos/inventario-consulta-orquestrador.service';
import {
  InventarioDigitacaoStruct,
  InventarioItemDigitacaoStruct,
} from '../../../../../shared/services/structs/suprimentos/inventario-digitacao.struct';

export interface InventarioResumoModalData {
  idInventario: number;
  datetimeConclusao?: string;
}

interface ResumoItemRow extends InventarioItemDigitacaoStruct {
  nomeLocalizacao: string;
}

@Component({
  selector: 'app-inventario-resumo-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './inventario-resumo-modal.component.html',
  styleUrls: ['./inventario-resumo-modal.component.css'],
})
export class InventarioResumoModalComponent implements OnInit {
  public isLoading: boolean = true;
  public digitacao: InventarioDigitacaoStruct | null = null;
  public itens: ResumoItemRow[] = [];

  constructor(
    private dialogRef: MatDialogRef<InventarioResumoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InventarioResumoModalData,
    private inventarioConsultaService: InventarioConsultaOrquestradorService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.inventarioConsultaService.getDigitacao(this.data.idInventario).subscribe({
      next: res => {
        this.isLoading = false;
        if (res.isError || !res.digitacao) {
          this.alertService.show('Erro', res.errorDescription || 'Não foi possível carregar o resumo.', AlertType.error);
          this.dialogRef.close();
          return;
        }

        this.digitacao = res.digitacao;
        this.itens = res.digitacao.localizacoes.flatMap(loc =>
          loc.itens.map(item => ({ ...item, nomeLocalizacao: loc.nomeLocalizacao }))
        );
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', err?.message || err, AlertType.error);
        this.dialogRef.close();
      },
    });
  }

  public get locaisEstoque(): string {
    const nomes = this.digitacao?.localizacoes.map(l => l.nomeLocalizacao) ?? [];
    return nomes.length ? nomes.join(', ') : '—';
  }

  public formatarQtd(valor?: number | null): string {
    if (valor == null) return '—';
    return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(valor));
  }

  public formatarMoeda(valor?: number | null): string {
    if (valor == null) return '—';
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor));
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
